import Container from "../Container/Container";
import Divider from "../Divider";
import React from "react";

const ContainerDivider = () => {
  return (
    <Container>
      <Divider />
    </Container>
  );
};

export default ContainerDivider;
